import { useAuthStore } from '@/stores';
import { api } from './api-client';

export async function checkAuthStatus(): Promise<{ isAuthenticated: boolean; user: any | null }> {
  try {
    const data = await api.get<{ success: boolean; user: any }>('/auth/me');
    
    if (data.success && data.user) {
      useAuthStore.getState().setUser(data.user);
      return { isAuthenticated: true, user: data.user };
    }
    
    useAuthStore.getState().setLoading(false);
    return { isAuthenticated: false, user: null };
  } catch (error) {
    console.error('Auth check error:', error);
    useAuthStore.getState().setLoading(false);
    return { isAuthenticated: false, user: null };
  }
}

export function useRequireAuth(redirectUrl = '/login'): boolean {
  const { isAuthenticated, isLoading } = useAuthStore();
  
  if (isLoading) {
    return false;
  }
  
  if (!isAuthenticated) {
    window.location.href = redirectUrl;
    return false;
  }
  
  return true;
}

export function useRequireAdmin(): boolean {
  const { user, isAuthenticated, isLoading } = useAuthStore();
  
  if (isLoading) {
    return false;
  }
  
  if (!isAuthenticated || user?.role !== 'admin') {
    window.location.href = '/';
    return false;
  }
  
  return true;
}

export async function login(email: string, password: string): Promise<{ success: boolean; error?: string }> {
  try {
    const data = await api.post<{ success: boolean; user: any; token: string; error?: string }>('/auth/login', { email, password });
    
    if (data.success) {
      useAuthStore.getState().login(data.user, data.token);
      return { success: true };
    }
    
    return { success: false, error: data.error || 'Error al iniciar sesión' };
  } catch (error: any) {
    return { success: false, error: error.message || 'Error de conexión' };
  }
}

export async function register(name: string, email: string, password: string): Promise<{ success: boolean; error?: string }> {
  try {
    const data = await api.post<{ success: boolean; user: any; token: string; error?: string }>('/auth/register', { name, email, password });
    
    if (data.success) {
      useAuthStore.getState().login(data.user, data.token);
      return { success: true };
    }
    
    return { success: false, error: data.error || 'Error al crear cuenta' };
  } catch (error: any) {
    return { success: false, error: error.message || 'Error de conexión' };
  }
}

export async function logout(): Promise<void> {
  try {
    await api.post('/auth/logout', {});
  } catch (error) {
    console.error('Logout error:', error);
  }
  
  useAuthStore.getState().logout();
  window.location.href = '/login';
}
